"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartSignin = exports.authenticateWithoutPassword = exports.authenticateByMagicLinkToken = exports.authenticate = void 0;

var _requester = require("./utils/requester");

var _storage = require("./utils/storage");

var _helpers = require("./utils/helpers");

var _builders = require("./builders");

var _schemas = require("./schemas");

var _enums = require("./enums");

const authenticate = (0, _requester.requestHandler)(async (username, password, requester = _requester.authRequester) => {
  const response = await requester().post(_enums.AUTH_ENDPOINT.loginPassword, await (0, _builders.buildLoginPayload)(username, password));
  const parsedData = await _schemas.authenticateSchema.validate(response.data);
  (0, _storage.setToken)(parsedData);
  (0, _storage.setLegacyToken)(parsedData);
  return parsedData;
});
exports.authenticate = authenticate;
const authenticateByMagicLinkToken = (0, _requester.requestHandler)(async (token, requester = _requester.authRequester) => {
  const response = await requester().post(_enums.AUTH_ENDPOINT.loginPassword, (0, _builders.buildLoginByTokenPayload)(token));
  const parsedData = await _schemas.authenticateSchema.validate(response.data);
  (0, _storage.setToken)(parsedData);
  (0, _storage.setLegacyToken)(parsedData, {
    isMagicLink: true
  });
  return parsedData;
});
exports.authenticateByMagicLinkToken = authenticateByMagicLinkToken;
const authenticateWithoutPassword = (0, _requester.requestHandler)(async (code, verificationTicket, requester = _requester.authRequester) => {
  const response = await requester().post(_enums.AUTH_ENDPOINT.loginPassword, (0, _builders.buildPasswordlessLoginPayload)(code, verificationTicket));
  const parsedData = await _schemas.authenticateSchema.validate(response.data);
  (0, _storage.setToken)(parsedData);
  (0, _storage.setLegacyToken)(parsedData);
  return parsedData;
});
exports.authenticateWithoutPassword = authenticateWithoutPassword;
const smartSignin = (0, _requester.requestHandler)(async (username, requester = _requester.authRequester) => {
  const encodedUsername = encodeURIComponent(username);
  const type = await (0, _helpers.getUsernameType)(username);
  const queryParams = `${type}=${encodedUsername}&customersFallback=true`;
  const requestURL = `${_enums.AUTH_ENDPOINT.smartSignin}?${queryParams}`;
  const response = await requester().get(requestURL);
  const parsedData = await _schemas.smartSigninSchema.validate(response.data);
  return parsedData;
});
exports.smartSignin = smartSignin;